import React from "react";
import "../Styles/styles.css";


const TRACe = () => (
    <div className="container" >
        <div className="section-title">
            <h2>TRAC<span className="text-lowercase">e</span></h2>
        </div>
        <div className="text-center">
            <p className="text-muted">GRC Governance, Risk and Compliance</p>
        </div>
        <div>
            <p>
                TRACe is an auditor's Workbench based on ISO standards. By using TRACe, auditors are automatically
                complying with the standard Plan-Do-Check-Act methodology promoted by ISO Standards. TRACe is designed
                to be flexible to enable auditors to define, plan and execute audits that cover different domains.
            </p>
            <p>
                TRACe is not industry specific and can be used across any business segment by defining appropriate
                Audit universe. Addresses the computing needs of vertical segment of audit professionals.
            </p>
            <p>
                It covers the complete life cycle of Risk, Compliance and Audit activities, from the audit planning
                stage to generating the final audit report. System has security functionalities including automatic
                logging of crucial audit activities ensures the creation and maintenance of an accurate log of audit
                related activities.
            </p>
            <p>
                TRACe is web based and can be accessed from anywhere using a browser, allowing auditor’s access to the
                system even when on the road or visiting an auditee.
            </p>
            <p>
                TRACe is built by using EDICT-Digital office framework and provides seamless integration with MS-Office,
                open office and supports integrated document management and workflow at every phase of an audit.
            </p>
            <p>
                Facility to maintain Reference library of Documents, publications, guidelines and other such documents.
            </p>
            <p>
                Product is available in two versions - Customizable enterprise version and Standard product for practicing auditors.
            </p>
            <a href="https://www.mmcspl.com/docs/Trace%20-%20Brochure.pdf" className="btn btn-primary mb-3" download>
                Click here to Download TRACe Brochure
            </a>
            <br />
            <a href="https://www.mmcspl.com/docs/TRACe%20Pa%20Brochure.pdf" className="btn btn-primary" download>
                Click here to Download TRACe-Pa Brochure
            </a>
        </div>
        <div className="my-5">
            <h5 className="text-primary">Governance</h5>
            <ul >
                <li >Digitally mimic Organization structure</li>
                <li >Roles and designations</li>
                <li >Approval procedures</li>
                <li >Issues Escalation procedure</li>
                <li >Maker and Checker concepts</li>
                <li >Authorizations and permissions</li>
                <li >Integration with Document Management</li>
            </ul>
        </div>
        <div className="mb-5">
            <h2 className="text-danger">Risk</h2>
            <ul >
                <li >Risk Assessments and Control Assessments</li>
                <li >Key Risk Indicators reporting</li>
                <li >Managing audit and non-audit issues</li>
                <li >Risk aggregation and dashboards</li>
                <li >Automated mail alerts for risk updates</li>
            </ul>
        </div>
        <div className="mb-5">
            <h2 className="text-success">Compliance</h2>
            <ul >
                <li >Checklist based compliance testing</li>
                <li >Regulatory compliance library</li>
                <li >Internal and external audit scheduling</li>
                <li >Review and assessment of compliance checks</li>
            </ul>
        </div>
        <div className="mb-5">
            <h2 className="text-warning">Audit</h2>
            <ul >
                <li >Plan and schedule periodic audits</li>
                <li >Various types: IS Audit, Statutory Audit, Compliance Audit</li>
                <li >Work Paper Management</li>
                <li >Audit Project Scheduling and Time Management</li>
                <li >Automated tracking and reporting</li>
            </ul>
        </div>
        <div className="mb-5">
            <h2 className="text-info">Data Capture</h2>
            <p className="lead">
                Facility to capture audit data from accounting systems, Excel sheets, or direct interfaces.
            </p>
            <ul >
                <li >Facility to capture audit data from accounting systems, Excel sheets, or direct interfaces.</li>
                <li >Data can be captured by Excel sheets or directly developing interface to the main accounting system.</li>
                <li >TRACe has been integrated with Intacct to capture transactions for audit from the cloud based accounting solution</li>
            </ul>
        </div>
    </div>
);

export default TRACe;
